/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Many/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Dropdown from 'DesignSystem/Dropdown/index'
import React from 'react'
import SelectAll from './SelectAll/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Many({
  children,
  viewPath = "/App/Account/Content/Settings/Content/TreatmentPlanTemplates/TxPlanTemplates/LocationChooser/Content/Many",
  onClick
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let locationsValueData = fromData.useDataValue({ viewPath,
context: 'locations',
})
let selectedLocationsValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'locations',
})
  return (<React.Fragment
>
<div
  data-testid="Many.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-awt4': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Many.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<Dropdown
  viewPath={`${viewPath}/Dropdown`}
 data="locations"
 from={locationsValueData}
 data="selected.locations"
 selected={selectedLocationsValueData}
 onClick={onClick}
 label="Locations"
 maxWidth={310}
 width={310}
 height={300}
 top={34}
 skipCallingOnClickWhenMoreThanOneItemAndNoneSelected={true}
/>
<SelectAll
  viewPath={`${viewPath}/SelectAll`}
/>
</div>
</div>
{children}
</React.Fragment>)
}